import React from "react";
import { styled } from "@material-ui/core/styles";
import { format, parseISO, toDate, isValid } from 'date-fns';
import ru from 'date-fns/locale/ru'

const Cell = styled("div")({
    display: "flex",
    alignItems: "center"
});

const calcToday = (date) => {
  let dirtyDate = parseISO(date);
  let originalDate = toDate(dirtyDate);
  if (isValid(originalDate)) {
    format(
      originalDate,
      'dd.MM.yyyy',
      {locale: ru}
    );
  }
}

const DateCell = cellData => {
  const date = cellData.text ? calcToday(cellData.text) : '';
  console.log(date);
    return <Cell>{date}</Cell>;
};

export default DateCell;
